// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.hand-scroll {
	scroll-behavior: initial;
	touch-action: none;
	user-select: none;  
}

.flash-task-insert-box {
	background-color: var(--bs-body-bg);
	/* border: 1px solid red; */
	border-radius: .5em;
	bottom: 2.2em;
	box-shadow: 0px 0px 10px rgba(255, 255, 255, .4);
	height: 0em;
	left: 1em;
	overflow: hidden;
	opacity: 0;
	position: absolute;
	right: 1em;
	transition: all .3s;
}

.flash-task-insert-box.open {
	height: 10em;
	opacity: 1;
}

.flash-task-insert-box textarea {
	border-radius: .5em;
	height: calc(100% - 2.4em);
	padding: .5em;
	width: 100%;
}

.toast .priority-box {
	border-radius: 6px;
	font-size: 14px;
	height: 20px;
	min-height: 20px;
	min-width: 20px;
    padding: 1px 3px;
	width: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/activity/style.css"],"names":[],"mappings":";AACA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,mCAAmC;CACnC,2BAA2B;CAC3B,mBAAmB;CACnB,aAAa;CACb,gDAAgD;CAChD,WAAW;CACX,SAAS;CACT,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,eAAe;IACZ,gBAAgB;CACnB,WAAW;AACZ","sourcesContent":["\r\n.hand-scroll {\r\n\tscroll-behavior: initial;\r\n\ttouch-action: none;\r\n\tuser-select: none;  \r\n}\r\n\r\n.flash-task-insert-box {\r\n\tbackground-color: var(--bs-body-bg);\r\n\t/* border: 1px solid red; */\r\n\tborder-radius: .5em;\r\n\tbottom: 2.2em;\r\n\tbox-shadow: 0px 0px 10px rgba(255, 255, 255, .4);\r\n\theight: 0em;\r\n\tleft: 1em;\r\n\toverflow: hidden;\r\n\topacity: 0;\r\n\tposition: absolute;\r\n\tright: 1em;\r\n\ttransition: all .3s;\r\n}\r\n\r\n.flash-task-insert-box.open {\r\n\theight: 10em;\r\n\topacity: 1;\r\n}\r\n\r\n.flash-task-insert-box textarea {\r\n\tborder-radius: .5em;\r\n\theight: calc(100% - 2.4em);\r\n\tpadding: .5em;\r\n\twidth: 100%;\r\n}\r\n\r\n.toast .priority-box {\r\n\tborder-radius: 6px;\r\n\tfont-size: 14px;\r\n\theight: 20px;\r\n\tmin-height: 20px;\r\n\tmin-width: 20px;\r\n    padding: 1px 3px;\r\n\twidth: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
